import { LocalStorageKeys } from 'constants/global';
import { UserTypes } from 'constants/user';
import { CurrentCompany } from 'interfaces';

export const useCanInviteInvestors = (data: CurrentCompany | null) => {
  const userType = localStorage.getItem(LocalStorageKeys.USER_TYPE) as UserTypes;
  const canInviteInvestors = data?.[`${userType}Actions`]?.canInviteInvestors ?? true;

  return canInviteInvestors;
};
